import { createAsyncSagaAction } from 'utils/reduxUtils';
import * as actionTypes from './actionTypes';

export const setShouldShowIncidentSub = shouldShowIncidentSub => ({
  type: actionTypes.SET_SHOULD_SHOW_INCIDENT_SUB,
  payload: shouldShowIncidentSub,
});

export const getGroupSubscriptionList = createAsyncSagaAction(actionTypes.GET_GROUP_SUBSCRIPTION);
export const getAlertSubscriptionList = createAsyncSagaAction(actionTypes.GET_ALERT_SUBSCRIPTION);
export const getIncidentSubscriptionList = createAsyncSagaAction(actionTypes.GET_INCIDENT_SUBSCRIPTION);
export const updateGroupSubscriptionList = createAsyncSagaAction(actionTypes.UPDATE_GROUP_SUBSCRIPTION);
export const updateAlertSubscriptionList = createAsyncSagaAction(actionTypes.UPDATE_ALERT_SUBSCRIPTION);
export const updateIncidentSubscriptionList = createAsyncSagaAction(actionTypes.UPDATE_INCIDENT_SUBSCRIPTION);
export const checkShowIncidentSub = createAsyncSagaAction(actionTypes.CHECK_SHOW_INCIDENT_SUBSCRIPTION);

export const clearSubscriptionsData = () => ({
  type: actionTypes.CLEAR_SUBSCRIPTION_DATA,
});
